import { Typography } from '@mui/material';
import NetZeroTermTarget from './NetZeroTermTarget';

type NetZeroGoalYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const NetZeroGoalYear = ({
  isCompletedTh,
  isCompletedEn,
}: NetZeroGoalYearProps) => {
  return (
    <>
      <Typography fontWeight={800} mt={2} sx={{ textDecoration: 'underline' }}>
        ปีเป้าหมาย
      </Typography>
      <Typography fontSize={12}>(โปรดระบุอย่างน้อย 1 เป้าหมาย)</Typography>
      <NetZeroTermTarget
        isCompletedTh={isCompletedTh}
        isCompletedEn={isCompletedEn}
        title="เป้าหมายระยะสั้น (Short-term target)"
        fieldPath="nearTermTarget"
      />
      <NetZeroTermTarget
        isCompletedTh={isCompletedTh}
        isCompletedEn={isCompletedEn}
        title="เป้าหมายระยะยาว (Long-term target)"
        fieldPath="longTermTarget"
      />
    </>
  );
};

export default NetZeroGoalYear;
